import { useSelector } from "react-redux";
import PiCreatorInteractionDropdown from "../../../components/PiCreatorDropdown/PiCreatorInteractionDropdown";
import { Actor } from "../../../models/Actor";
import {
  selectSelectedTake3D,
  selectSelectedTakeActors,
} from "../../../app/slices/TrainingSlice";
import ActorAvatar from "../../../components/actors/ActorAvatar";
import classNames from "classnames";
import { Prop } from "../../../models/Prop";
import usePropHelper from "../../../hooks/PropHelper";
import PropIcon from "../../../icons/PropIcon";

function ConversationActorDropdownItem(props: {
  actor: Actor;
  onClick: () => void;
  selected: boolean;
}) {
  const { actor, onClick, selected } = { ...props };
  return (
    <div
      className={classNames(
        "flex justify-start items-center gap-[12px] py-[4px] px-[8px] rounded-[5px]",
        {
          "bg-interaction-text-selectedBackground": selected,
        }
      )}
      onClick={onClick}
    >
      <ActorAvatar actor={actor} size="24" />
      <div
        className={classNames(
          "my-auto font-medium truncate text-[14px] text-interaction-text-primary"
        )}
      >
        {actor.workingName}
      </div>
    </div>
  );
}

function ConversationPropDropdownItem(props: {
  prop: Prop;
  onClick: () => void;
  selected: boolean;
}) {
  const { prop, onClick, selected } = props;
  return (
    <div
      className={classNames(
        "flex justify-start items-center gap-[12px] py-[4px] px-[8px] rounded-[5px]",
        {
          "bg-interaction-text-selectedBackground": selected,
        }
      )}
      onClick={onClick}
    >
      <PropIcon size={24} />
      <div className="my-auto font-medium truncate text-[14px] text-interaction-text-primary">
        {prop.name}
      </div>
    </div>
  );
}

export default function ConversationActorDropdown(props: {
  selectedObjectId: string;
  interactionId: string;
  onClick: (objectId: string) => void;
}) {
  const { selectedObjectId, onClick } = { ...props };
  const actors: Actor[] = useSelector(selectSelectedTakeActors);
  const take = useSelector(selectSelectedTake3D);
  const { getBubbleTargetProps } = usePropHelper();
  const propsInTake = take
    ? getBubbleTargetProps(take, {
        kind: "timeline",
        interactionId: props.interactionId,
      })
    : [];

  const selectedActor = actors.find((actor) => actor.id === selectedObjectId);
  const selectedProp = propsInTake.find((prop) => prop.id === selectedObjectId);

  const actorVisuals = actors.map((actor, index) => {
    return (
      <ConversationActorDropdownItem
        key={index}
        actor={actor}
        onClick={() => onClick(actor.id)}
        selected={selectedActor?.id === actor.id}
      />
    );
  });

  const propVisuals = propsInTake.map((prop) => (
    <ConversationPropDropdownItem
      key={prop.id}
      prop={prop}
      onClick={() => onClick(prop.id)}
      selected={selectedProp?.id === prop.id}
    />
  ));

  const trigger = selectedProp ? (
    <ConversationPropDropdownItem
      prop={selectedProp}
      onClick={() => {}}
      selected={false}
    />
  ) : (
    <ConversationActorDropdownItem
      actor={selectedActor ?? actors.find((actor) => actor.id === "player")!}
      onClick={() => {}}
      selected={false}
    />
  );

  return (
    <div>
      <PiCreatorInteractionDropdown
        trigger={<>{trigger}</>}
        items={[...actorVisuals, ...propVisuals]}
        side="top"
        avoidCollisions={false}
      />
    </div>
  );
}
